import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FocusInputType, LocalService, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {
  index = 0; txtContent = ''; htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private activeModal: NgbActiveModal) { 
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_comment: 'txt_comment' + this.htmlId
    };
  }

  ngOnInit(): void {
  }

  onPopupSave() {
    if (this.txtContent && this.txtContent.trim() != '') {
      this.activeModal.close({ event: TriggeredEvent.Ok, data: this.txtContent.trim() });
    } else {
      this.txtContent = '';
      this.localService.onFocusNextInput(this.elementIds.txt_comment, FocusInputType.TextBox);
    }
  }

}
